import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=490a281e&scoped=true&"
import script from "./Divider.vue?vue&type=script&lang=js&"
export * from "./Divider.vue?vue&type=script&lang=js&"
import style0 from "./Divider.vue?vue&type=style&index=0&id=490a281e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../share_webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a281e",
  null
  
)

export default component.exports